<template>
  <v-main class="grey lighten-3">
    <v-container id="core-view" fluid>
      <v-fade-transition mode="out-in">
        <router-view />
      </v-fade-transition>
    </v-container>
  </v-main>
</template>

<script>
export default {
  name: 'CoreView',

  metaInfo() {
    return {
      title: 'Clean Intel',
    };
  },
};
</script>

<style lang="scss">
@media screen {
  #core-view {
    padding-top: 2em;
  }
}
</style>
